// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RJXJ","newExpiryDate":"styles_newExpiryDate__ePNl7","footer":"styles_footer__2DA0c"};